import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ImageIcon } from "lucide-react";
import { ABOUT_IMAGE, VAN_IMAGE, MANIFESTO } from "../data";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="nosotros" className="bg-background py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <motion.span variants={reveal} custom={0} initial="hidden" whileInView="show" viewport={{ once: true }} className="text-xs uppercase tracking-[0.25em] font-bold text-electric">
              Sobre nosotros
            </motion.span>
            <motion.h2 variants={reveal} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }} className="font-heading font-bold text-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6">
              Un oficio hecho de precisión.
            </motion.h2>
            <motion.p variants={reveal} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }} className="mt-8 text-muted-foreground text-base md:text-lg leading-relaxed">
              Iván Hondal López realiza el montaje de cerramientos de PVC y aluminio con
              acabados de calidad, cuidando cada detalle. Instalamos ventanas de PVC y
              ventanas de aluminio en Cantabria, mosquiteras a medida, persianas, estores y
              puertas, además de la conversión a oscilobatiente, cerrajería y reparación de
              ventanas.
            </motion.p>

            <div className="mt-12 grid grid-cols-2 gap-6 max-w-sm">
              {[["+20", "años de oficio"], ["100%", "a medida"]].map(([num, label], i) => (
                <motion.div key={i} variants={reveal} custom={3 + i} initial="hidden" whileInView="show" viewport={{ once: true }}>
                  <div className="font-heading font-black text-ink text-3xl lg:text-4xl">{num}</div>
                  <div className="text-xs text-muted-foreground mt-1 uppercase tracking-wide">{label}</div>
                </motion.div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <figure className="relative overflow-hidden aspect-[16/10] bg-muted mb-8">
              <motion.img style={{ y }} src={VAN_IMAGE} alt="Furgoneta rotulada de Ventanas Hondal — servicio a domicilio en Cantabria" loading="lazy" decoding="async" className="w-full h-[116%] object-cover" />
              <figcaption className="absolute bottom-0 left-0 bg-ink/80 backdrop-blur-sm text-white text-xs font-semibold uppercase tracking-wider px-4 py-2">
                Nos desplazamos por toda Cantabria
              </figcaption>
            </figure>
            <div className="border-t border-border">
              {MANIFESTO.map((m, i) => (
                <motion.div key={m.n} variants={reveal} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }} className="flex gap-6 py-6 border-b border-border">
                  <span className="font-heading font-light text-5xl text-border leading-none">{m.n}</span>
                  <div>
                    <h3 className="font-heading font-semibold text-ink text-xl">{m.title}</h3>
                    <p className="text-muted-foreground mt-1 text-sm md:text-base leading-relaxed">{m.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
